import {
	ClientPropertyTypeEnum,
	type ClientPropertyVehicleDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPropertyTitle } from "web_myplann/Portfolio/Hooks/usePropertyTitle";
import { EditCarForm } from "web_myplann/Portfolio/Pages/CarEdit/EditCarForm";
import { PropertyEditLayout } from "web_myplann/Portfolio/PortfolioShared/PropertyEditLayout";

export const EditCarPage = () => {
	const { t } = useResource();

	return (
		<PropertyEditLayout<ClientPropertyVehicleDetailResponseDTO>
			expectedTypes={[ClientPropertyTypeEnum.AutoMoto]}
			title={(property) =>
				t(Resources.Portfolio.EditProperty.title, {
					type: getPropertyTitle(property, t),
				})
			}
		>
			{({ property, propertyId, detailRoute }) => (
				<EditCarForm
					propertyId={propertyId}
					property={property}
					detailRoute={detailRoute}
				/>
			)}
		</PropertyEditLayout>
	);
};
